/** Legal pages live on the current org site, e.g. https://org.example.com/privacy */
export function getOrgLegalPageUrl(path = '/privacy') {
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? String(window.location.origin).replace(/\/+$/, '')
      : '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${normalizedPath}`;
}

export function getPrivacyPolicyUrl() {
  return getOrgLegalPageUrl('/privacy');
}
